<template lang="pug">
	.audio-tracker-slider-button.flex-col.center.align-center(@click="onClick", @mousedown="onMouseDown", @mouseup="() => movementTotal.active = false", :style="{ width: getVHValue(length, width), height: getVHValue(width, length), '--handleSize': handleSize }", :class="[orientation, movementTotal.active ? 'active' : null]")
		.title.font-small.upper(v-if="title", :style="{ '--color': color }") {{title}}
		.slider-item(:class="[orientation]", :style="{ width: getVHValue(length, width), height: getVHValue(width, length) }")
			.slider-line(ref="line", @click="onClick", :style="{ ...getVHStyle(['--width', '--height'], ['100%', '35%']), ...getVHValue({ top: '50%' }, { left: '50%' }), ...getVHValue({ transform: 'translateY(-50%)' }, { transform: 'translateX(-50%)' }), ...getVHValue({ left: '0px' }, { top: '0px' })  }")
			.value-line(:style="{ '--value': `${getVHValue(percentageValue, percentageValue)}%`, '--color': color, ...getVHStyle(['width', 'height'], ['calc(var(--value) - 4px)', '40%']), ...getVHValue({ top: '50%', left: '0px' }, { bottom: '0px', left: '50%' }), ...getVHValue({ transform: 'translateY(-50%)' }, { transform: 'translateX(-50%)' }) }")
			.slider-handler(@mousedown="movementTotal.active = true", @mouseup="movementTotal.active = false", :style="{ '--rotate': getVHValue('90deg', '0deg'), '--value': `${getVHValue(percentageValue, 100 - percentageValue)}%`, '--width': getVHValue(handleWidth, handleSize), '--size': getVHValue(handleSize, handleWidth), ...getVHStyle(['left', 'top'], ['var(--value)', '50%']) }")
			.value-popover(:style="{ '--rotate': getVHValue('-90deg', '0deg'), '--value': `${getVHValue(percentageValue, 100 - percentageValue)}%`, ...getVHStyle(['left', 'top'], [`calc(var(--value) + ${handleSize} + 2px)`, '50%']) }") {{(innerValue * 100).toFixed(0)}}%
</template>

<script>
	import $ from 'jquery';
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'audioTracker.AudioTrackerSliderButton',
		name: 'audio-tracker-slider-button',
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: VueTypes.number.def(0),
			min: VueTypes.number.def(0),
			max: VueTypes.number.def(100),
			step: VueTypes.number.def(1),
			stepSensivity: VueTypes.number.def(1.5),
			width: VueTypes.any.def('12px'),
			length: VueTypes.any.def('100%'),
			formatter: VueTypes.any.def(null),
			title: VueTypes.string.def(null),
			color: VueTypes.string.def('#f27649'),
			round: VueTypes.number.def(0),
			handleSize: VueTypes.any.def('10%'),
			handleWidth: VueTypes.any.def('80%'),
			orientation: VueTypes.oneOf(['vertical', 'horizontal']).def('horizontal'),
			isLogarithmic: VueTypes.bool.def(false)
		},
		data() {
			return {
				madeStep: 0,
				innerValue: this.getProcessedValue(this.value, true),
				movementTotal: {
					x: 0,
					y: 0,
					moved: false,
					active: false
				},
				innerChange: false
			};
		},
		computed: {
			total() {
				return this.max - this.min;
			},
			absoluteValue() {
				return this.innerValue - this.min;
			},
			percentageValue() {
				return this.absoluteValue * 100 / this.total;
			}
		},
		watch: {
			value(v) {
				if (!this.innerChange)
					this.innerValue = this.getProcessedValue(v, true);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.sliderButton = this;
			this.$emitChange = _.debounce(this.emitChange, 10, {
				'leading': false,
				'trailing': true
			});
		},
		deactivated() {
			this.bindMouseMove(false);
		},
		destroyed() {
			delete this.$emitChange;
		},
		methods: {
			getProcessedValue(val, inverted) {
				if (!this.isLogarithmic || !val) return val;
				var absoluteVal = val - this.min;
				var total = this.max - this.min;
				var percentageVal = absoluteVal * 100 / total;

				// position will be between 0 and 100
				var minp = 0;
				var maxp = 100;

				// The result should be between 100 an 10000000
				var minv = Math.log(1);
				var maxv = Math.log(100);

				// calculate adjustment factor
				var scale = (maxv-minv) / (maxp-minp);

				var resultVal = inverted ? (Math.log(percentageVal)-minv) / scale + minp : Math.exp(minv + scale*(percentageVal-minp));
				var result =  Math.max(this.min, Math.min(this.max, total * resultVal / 100));

				return result;
			},
			emitChange() {
				this.innerChange = true;
				this.$emit('change', this.getProcessedValue(this.innerValue));
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.innerChange = false;
				})
			},
			getVHStyle(opts, values) {
				const style = {};
				style[this.getVHValue(opts[0], opts[1])] = values[0];
				style[this.getVHValue(opts[1], opts[0])] = values[1];
				return style;
			},
			getVHValue(val1, val2) {
				return this.orientation === 'horizontal' ? val1 : val2;
			},
			bindMouseMove(active) {
				if (active) {
					$(window.document).bind('mousemove', this.onMouseMove);
					$(window.document).bind('mouseup', this.onMouseUp);
				}
				else {
					$(window.document).unbind('mousemove', this.onMouseMove);
					$(window.document).unbind('mouseup', this.onMouseUp);
					this.movementTotal.active = false;
				}
			},
			setValue(val) {
				if (__DEBUG__)
					console.debug('Set value', { val, rnd: this.round });
				this.innerValue = Math.max(this.min, Math.min(this.max, val));
				this.innerValue = parseFloat(parseFloat(this.innerValue).toFixed(this.round));
				this.$emitChange();
			},
			onMouseDown(e) {
				if (__DEBUG__)
					console.debug('On mouse down', e);
				this.movementTotal = { x: 0, y: 0, moved: false, active: true };
				this.bindMouseMove(true);
			},
			onMouseUp() {
				this.bindMouseMove(false);
			},
			onMouseMove(e) {
				if (e.buttons === 1 && this.movementTotal.active) {
					var totalLength = this.getVHValue($(this.$refs.line).width(), $(this.$refs.line).height());
					var position = this.getVHValue(e.originalEvent.movementX, -e.originalEvent.movementY);
					var delta = position * this.total / totalLength;
					this.madeStep += delta;
					if (Math.abs(this.madeStep) >= this.step) {
						this.setValue(this.innerValue + this.madeStep);
						this.madeStep = 0;
						this.movementTotal.moved = true;
					}
				} else {
					this.movementTotal.active = false;
				}
			},
			onClick(e) {
				if (this.movementTotal.moved) return;
				var totalLength = this.getVHValue($(this.$refs.line).width(), $(this.$refs.line).height());
				var position = this.getVHValue(e.offsetX, totalLength - e.offsetY);
				this.setValue(position * this.total / totalLength);
				if (__DEBUG__)
					console.debug('On click', { e, x: e.offsetX, y: e.offsetY, position });
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-slider-button {
		@import "main/themes/generated/variables.base.scss";

		position: relative;
		user-select: none;

		&.horizontal {
			margin: 0px calc(var(--handleSize) / 2);
		}

		&.vertical {
			padding: calc(var(--handleSize) / 2) 0px;
		}

		.slider-item {
			position: relative;
			width: 100%;
			height: 100%;
			padding: 5px;

			> .slider-line {
				border-radius: 4px;
				position: absolute;
				background: #333;
				box-shadow: rgb(255, 255, 255, 0.47) -3px -3px 1px -2px inset, rgb(255, 255, 255, 0.4) 1px 1px 3px -2px inset;
				pointer-events: none;
				width: var(--width);
				height: var(--height);
			}

			> .slider-handler {
				position: absolute;
				transform: translateY(-50%) translateX(-50%);
				background: #fff;
				border: 0px solid rgba(180,180,180);
				border-radius: 4px;
				box-shadow: rgba(0, 0, 0, 0.7) 0px 0px 4px -1px;
				width: var(--size);
				height: var(--width);
				background: linear-gradient(var(--rotate), rgba(120,120,120,1) 0%, rgba(224,224,224,1) 33%, rgba(176,176,176,1) 33%, rgba(224,224,224,1) 53%, rgba(176,176,176,1) 53%, rgba(224,224,224,1)  73%, rgba(190,190,190,1) 73%, rgba(120,120,120,1) 100%);
				transition: 0.1s;
			}

			> .value-line {
				border-radius: 4px;
				position: absolute;
				background: var(--color);
				pointer-events: none;
				box-shadow: rgb(255 255 254 / 47%) -4px -4px 0px -2px inset;
				transition: 0.1s;
			}

			> .value-popover {
				position: absolute;
				transform: translateY(-50%) translateX(-50%);
				background: #fff;
				border: 0px solid rgba(180,180,180);
				border-radius: 4px;
				box-shadow: rgba(0, 0, 0, 0.7) 0px 0px 4px -1px;
				font-size: 10px;
				padding: 2px;
				transition: 0.1s;
				color: #333;
				pointer-events: none;
				opacity: 0;
				z-index: 1000;
			}
		}

		&:hover, &.active {
			.slider-item {
				> .value-popover {
					opacity: 1;
				}
			}
		}
	}
</style>
